// src/utils/firebase.js — v2
// CHANGED FROM v1 (5 Aug 2026): REAL FIX — getAuth(app) previously ran
// synchronously the moment this file was imported, which happens as
// soon as StoreContext.jsx loads — i.e. before the page has painted
// anything, on every single page including the homepage where nobody
// needs to be logged in yet. getAuth() itself kicks off a cross-domain
// iframe load (auth/iframe.js, since authDomain differs from the site's
// real domain) to check persisted login state. Confirmed via PageSpeed
// Insights' Network dependency tree as a real ~2.4s chunk of the
// critical path, and independently confirmed by Firebase's own
// extended tooling docs (reactfire), which explicitly recommend
// deferring Auth provider setup specifically "to avoid loading a
// large iframe on mobile."
// Auth SDK now loads lazily via dynamic import() the FIRST TIME it's
// actually requested (getFirebaseAuth() / getGoogleProvider()), not at
// module-import time. StoreContext.jsx calls this from inside a
// useEffect, which only runs after the page's first paint — so the
// iframe load now happens after something is already visible, not
// before. Both loaders cache their result (module + instance), so
// repeated calls after the first are instant, not re-triggering a new
// import.
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyAQjFuOi5Zh2AxueHbgJ_jaafYyh-PWO_Q",
  authDomain: "nobrandstore-35cd9.firebaseapp.com",
  projectId: "nobrandstore-35cd9",
  storageBucket: "nobrandstore-35cd9.firebasestorage.app",
  messagingSenderId: "309673485870",
  appId: "1:309673485870:web:a9bd463b66043856bc21bf"
};

const app = initializeApp(firebaseConfig);

let authModulePromise = null;
let authInstance = null;
let googleProviderInstance = null;

function loadAuthModule() {
  if (!authModulePromise) {
    authModulePromise = import('firebase/auth');
  }
  return authModulePromise;
}

// Returns { auth, authModule } — authModule gives callers access to
// the named exports (onAuthStateChanged, signInWithPopup, signOut,
// signInWithCustomToken, etc.) without needing their own separate
// static import of 'firebase/auth' anywhere else in the app.
export async function getFirebaseAuth() {
  const mod = await loadAuthModule();
  if (!authInstance) {
    authInstance = mod.getAuth(app);
  }
  return { auth: authInstance, authModule: mod };
}

export async function getGoogleProvider() {
  const mod = await loadAuthModule();
  if (!googleProviderInstance) {
    googleProviderInstance = new mod.GoogleAuthProvider();
  }
  return googleProviderInstance;
}